import SharedSvg from '../../shared/shared-svg';
import { pagesConfig } from '../../shared/pages-config';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';

export default function FormSkeleton() {
  const theme = useTheme();
  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <Card sx={{ width: '100%', height: '100%', overflow: 'hidden' }}>
        <Grid container direction="column" sx={{ height: '100%' }}>
          {/* Title */}
          <Grid sx={{ p: 1.5, px: 4, flexShrink: 0 }}>
            <Stack direction="row" spacing={1.8} alignItems="center">
              <SharedSvg variant="formAccent" />
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 400,
                }}
              >
                {pagesConfig.addLicense.name}
              </Typography>
            </Stack>
          </Grid>
          <Grid
            container
            sx={{ flex: 1, minHeight: 0, overflow: 'hidden', width: '100%' }}
          >
            {/* Stepper */}
            <Grid
              sx={{
                p: 3,
                pl: 5,
                pt: 0,
                pr: 2,
                minHeight: 0,
                maxHeight: '90%',
                overflowY: 'auto',
                width: '18%',
              }}
            >
              <Grid container spacing={2} size={{ xs: 10 }} sx={{ pt: 2 }}>
                <Grid size={{ xs: 12 }}>
                  <Skeleton variant="rounded" width={'100%'} height={20} />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <Skeleton variant="rounded" width={'100%'} height={20} />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <Skeleton variant="rounded" width={'100%'} height={20} />
                </Grid>
              </Grid>
            </Grid>
            {/* Content Area */}
            <Grid
              sx={{
                p: 4,
                pt: 0,
                pl: 0,
                pr: 6,
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                width: '82%',
                minHeight: 0,
              }}
            >
              <Box sx={{ flex: 1, overflowY: 'auto', minHeight: 0, p: 2 }}>
                <Stack gap={1} sx={{ mb: 4 }}>
                  <Stack direction="row" alignItems="center">
                    <Skeleton variant="rounded" width={500} height={32} />
                  </Stack>
                  <Grid
                    container
                    spacing={1}
                    size={{ xs: 5 }}
                    sx={{ alignItems: 'baseline' }}
                  >
                    <Grid size={{ xs: 6 }}>
                      <Skeleton variant="rounded" width={'100%'} height={30} />
                    </Grid>
                    <Grid size={{ xs: 3 }}>
                      <Skeleton variant="rounded" width={'100%'} height={48} />
                    </Grid>
                    <Grid size={{ xs: 3 }}>
                      <Skeleton variant="rounded" width={'100%'} height={30} />
                    </Grid>
                  </Grid>
                  <Grid container spacing={1} size={{ xs: 4 }} sx={{ mt: 1 }}>
                    <Grid size={{ xs: 12 }}>
                      <Skeleton variant="rounded" width={'100%'} height={25} />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                      <Skeleton variant="rounded" width={'100%'} height={25} />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                      <Skeleton variant="rounded" width={'100%'} height={25} />
                    </Grid>
                  </Grid>
                  <Card sx={{ mt: 2 }}>
                    <CardContent>
                      <Stack flexDirection={'row'} gap={2}>
                        <Stack spacing={1} sx={{ width: '100%' }}>
                          <Skeleton variant="rounded" width={200} height={20} />
                          <Skeleton variant="rounded" width={400} height={40} />
                          <Divider sx={{ my: 2 }} />
                          <Skeleton variant="rounded" width={200} height={20} />
                          <Skeleton variant="rounded" width={500} height={20} />
                          <Skeleton variant="rounded" width={500} height={20} />
                        </Stack>
                      </Stack>
                    </CardContent>
                  </Card>
                </Stack>
              </Box>
            </Grid>
          </Grid>

          <Grid
            sx={{
              p: 3,
              pt: 0,
              pb: 1.5,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flexShrink: 0,
            }}
          >
            <Button
              sx={{
                color: theme.palette.primary.main,
                border: '1px solid',
                borderColor: theme.palette.primary.main,
              }}
            >
              Discard
            </Button>
            <Stack direction="row" spacing={2}>
              <Button variant="contained" disabled={true}>
                {'Next'}
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );
}
